module.exports = __webpack_public_path__ + "img/service-dashuju2.88895be9.svg";